import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { errorHandler, getErrorMessage } from '../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import { STATUS_TICKET_CONSTANT } from '../../constants/statusTicketConstant';
import { ROLE_CATEGORY_CONSTANT } from '../../constants/roleCategoryConstant';
import { CheckPermissionComponent } from '../../util/permission';
import { TICKET_LIST_ALL_ISSUE_UPDATE, TICKET_LIST_ALL_ISSUE_UPDATE_ASSIGNEE } from '../../constants/menuPermissionConstant';
import API_TICKET_LIST from '../../api/apiTicketList';
import IconIssueDescriptionBlue from '../../assets/icons/IconIssueDescriptionBlue';
import Alert from '../Alert/Alert';
import ActionType from '../../redux/reducer/globalActionType';

class TicketComplaintIssue extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showComplaintIssueModal: false,
            title: '',
            description: '',
            showSuccessAlert: false,
            showAlertError: '',
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleOpen = () => {
        this.setState({
            title: this.props.data.issue_title,
            description: this.props.data.issue_desc,
            showComplaintIssueModal: true
        })
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleSubmit = e => {
        e.preventDefault();

        if (this.state.title === this.props.data.issue_title && this.state.description === this.props.data.issue_desc) {
            return this.setState({ showAlertError: true })
        }

        const data = {
            issue_title: this.state.title,
            issue_desc: this.state.description,
            updated_at: this.props.data.updated_at
        }

        API_TICKET_LIST.putDataUpdateTitle(data, this.props.data.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                    showComplaintIssueModal: false
                })
                setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                this.props.refresh();
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    checkCustomerServiceAssignee = () => {
        if (this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO && this.props.userDetail.nexcare_id !== this.props.data.assignee_id) return false
        return true
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_ISSUE_UPDATE, TICKET_LIST_ALL_ISSUE_UPDATE_ASSIGNEE]} userPermission={this.props.userDetail.permissions}>
                <button type="button" id="btncomplaintissue" className={this.props.data.status === STATUS_TICKET_CONSTANT.IN_PROGRESS && window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL) && this.checkCustomerServiceAssignee() ? "bg-white text-darkblue flex items-center rounded-lg focus:outline-none py-2 px-5 mx-1" : "hidden"} onClick={() => this.handleOpen()}>
                    <IconIssueDescriptionBlue />
                    <span className="ml-1">Keluhan</span>
                </button>

                <div className={this.state.showComplaintIssueModal ? "block" : "hidden"}>
                    <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="border-0 rounded-2xl shadow-lg bg-white outline-none focus:outline-none p-10 w-1/2">
                            <div className="header flex justify-between">
                                <div></div>
                                <FontAwesomeIcon icon={faTimes} className="cursor-pointer" id="btncopmlaintissueclose" onClick={() => this.setState({ showComplaintIssueModal: false })} />
                            </div>
                            <form onSubmit={this.handleSubmit}>
                                <p className="text-darkblue text-center text-3xl font-medium">Keluhan</p>
                                <div className="my-5">
                                    <label htmlFor="tsltitle">Judul Keluhan</label>
                                    <input
                                        id="tsltitle"
                                        type="text"
                                        className="form-control"
                                        placeholder="Tulis Judul Keluhan"
                                        name="title" value={this.state.title}
                                        onChange={this.handleChange}
                                        minLength="10"
                                        maxLength="100"
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="my-5">
                                    <label htmlFor="tmldescription">Deskripsi Keluhan</label>
                                    <textarea
                                        id="tmldescription"
                                        className="form-control resize-none h-48"
                                        placeholder="Tulis Deskripsi Keluhan"
                                        name="description"
                                        value={this.state.description}
                                        onChange={this.handleChange}
                                        minLength="10"
                                        maxLength="300"
                                    />
                                </div>
                                <div className="flex justify-center items-center">
                                    <button type="button" id="btncancel" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none px-10 py-2 mt-3 mr-2" onClick={() => this.setState({ showComplaintIssueModal: false })}>Batal</button>
                                    <button type="submit" id="btnsave" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none px-10 py-2 mt-3 ml-2">Simpan</button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </div>
                <Alert show={this.state.showSuccessAlert} icon="success" title="Data berhasil disimpan!" />
                <Alert show={this.state.showAlertError} icon="warning" title="Tidak ada perubahan data!" close={() => this.setState({ showAlertError: false })} ok />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketComplaintIssue);